// extracted by mini-css-extract-plugin
export default {"container":"LandingMobile_container__38GSS"};